export const CHARS_URDU: Array<string> = [
    "ا",
    "آ",
    "آ",
    "أ",
    "ب",
    "پ",
    "ت",
    "ٹ",
    "ث",
    "ج",
    "چ",
    "ح",
    "خ",
    "د",
    "ڈ",
    "ذ",
    "ر",
    "ڑ",
    "ز",
    "ژ",
    "س",
    "ش",
    "ص",
    "ض",
    "ط",
    "ظ",
    "ع",
    "غ",
    "ف",
    "ق",
    "ک",
    "گ",
    "ل",
    "م",
    "ن",
    "ں",
    "و",
    "ؤ",
    "ه",
    "ہ",
    "ۂ",
    "ھ",
    "ء",
    "ی",
    "ئ",
    "ے",
    "ً",
    "َ",
    "ِ",
    "ُ",
];
